import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import NewTimeline from './new-timeline-icon.svg';

function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <NewTimeline {...validProps} />;
}
SvgComponent.iconName = 'newTimeline';

export const NewTimelineIcon = svgIconWrapper(SvgComponent);
